export default function InfoSection() {
  return (
    <section className="py-16 md:py-24 bg-white border-t border-gray-100">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        {/* Tag */}
        <span className="inline-block text-green-600 text-xs font-bold uppercase tracking-widest mb-4">
          Información actualizada
        </span>

        {/* Main heading */}
        <h2 className="text-2xl md:text-3xl font-extrabold text-gray-900 mb-5 tracking-tight leading-snug">
          ¿Cuál es el precio del dólar hoy en Venezuela?
        </h2>

        {/* Paragraphs */}
        <div className="space-y-5 text-gray-600 text-base leading-relaxed">
          <p>
            Consulta el <strong className="text-gray-800">dólar hoy en Venezuela</strong> actualizado en tiempo real. Mostramos el{' '}
            <strong className="text-gray-800">dólar paralelo</strong>, <strong className="text-gray-800">Monitor Dólar</strong> y la{' '}
            <strong className="text-gray-800">tasa oficial del BCV</strong> para que tengas la información más precisa.
          </p>

          <p>
            El <strong className="text-gray-800">precio del dólar hoy</strong> cambia constantemente, por eso actualizamos los datos
            diariamente para ayudarte a tomar mejores decisiones al enviar dinero a Venezuela.
          </p>

          <p>
            También puedes comparar servicios como <strong className="text-gray-800">Wise</strong>,{' '}
            <strong className="text-gray-800">Remitly</strong> y <strong className="text-gray-800">Western Union</strong> para
            encontrar la mejor tasa de cambio.
          </p>
        </div>

        {/* Divider line */}
        <div className="mt-10 border-t border-gray-100"></div>
      </div>
    </section>
  );
}
